import React, { useState, useEffect } from "react";
import "./Topics.css";
import LeftSidebar from "../../components/LeftSideBar";
import TopicCard from "./TopicCard";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import fetchProtectedData from "../auth/ProtectDataHeader";
import withTokenRefresh from "../auth/RefreshToken";
import ReactGA from "react-ga4";
import PaymentModal from "../payment/PaymentModal";
import SubscribeInfoModal from "../payment/SubscribeInfoModal";

function Topics() {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const selectedCourse = queryParams.get('course') || 'basic-python';
  const [API_ENDPOINT, setApiEndpoint] = useState(null);

  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);

  const [showInfoText, setShowInfoText] = useState("");

  const openPaymentModal = () => setShowPaymentModal(true);
  const closePaymentModal = () => setShowPaymentModal(false);

  const openInfoModal = (text) => {
    if (text) {
      setShowInfoText(text);
    } else {
      setShowInfoText("");
    }
    setShowInfoModal(true);
  };
  const [infoText, setInfoText] = useState("");

  const closeInfoModal = () => setShowInfoModal(false);
  const [subscriptionType, setSubscriptionType] = useState(null);
  const [subscriptionEndDate, setSubscriptionEndDate] = useState(null);
  const navigate = useNavigate();
  const [user_id, setUserId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const protectedData = await withTokenRefresh(fetchProtectedData);

        if (!protectedData) {
          navigate("/login");
          return;
        }
        setUserId(protectedData);

        const API_ENDPOINT = `/api/theories/topics?course_name=${selectedCourse}&user_id=${protectedData}`;

        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        

        const sortedTopics = data.topics
          .sort((a, b) => a.order - b.order)
          .map((topic) => {
            const progress = `${topic.tasks_solved}/${topic.total_tasks}`;
            return {
              title: topic.topic,
              title_front: topic.topic_front,
              progress: progress === "0/0" ? null : progress,
              course_name: topic.course_name,
              g_status: topic.g_status,
              order: topic.order
            };
          });
        setTopics(sortedTopics);

        const SUB_ENDPOINT = `/api/subscription/?user_id=${protectedData}`;
        const subscriptionResponse = await fetch(SUB_ENDPOINT, {
          method: "GET",
          headers: { Accept: "application/json" },
        });
        const subscriptionData = await subscriptionResponse.json();
        setSubscriptionType(subscriptionData.status);
        const subscriptionEndDate = new Date(
          subscriptionData.current_period_end
        );
        setSubscriptionEndDate(
          subscriptionEndDate.toLocaleDateString().replace(/\//g, "-")
        );
        if (subscriptionData.status === "expired") {
          navigate("/courses");
        }
      } catch (err) {
        setError(err.message);
        navigate("/login");
        return;
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [API_ENDPOINT]);

  const totalTasksSolved = topics.reduce((acc, topic) => {
    if (topic.progress) {
      const [solved] = topic.progress.split("/").map(Number);
      return acc + solved;
    }
    return acc;
  }, 0);

  const totalTasks = topics.reduce((acc, topic) => {
    if (topic.progress) {
      const [, total] = topic.progress.split("/").map(Number);
      return acc + total;
    }
    return acc;
  }, 0);

  const totalProgress = `${totalTasksSolved}/${totalTasks}`;

  const handleCardClick = (topic, course_name, g_status, order) => {
    if (g_status === 'done') {
      navigate(`/theory_new?topic=${topic}&course_name=${course_name}`);
    } else if (g_status === 'in_progress') {
      setShowInfoModal(true);
      if (order < 2) {
        setShowInfoText("Скоро эта тема появится.");
      } else {
        setShowInfoText("Купите подписку чтобы изучить эту тему.");
      }
    }
  };
  
  if (loading) {
    return (
      <div className="progress-container">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="progress-container">
        <p>Error fetching progress data: {error}</p>
      </div>
    );
  }

  return (
    <div className="topics-container">
      {showInfoModal && (
        <SubscribeInfoModal
          onClose={closeInfoModal}
          subscriptionType={subscriptionType}
          text={showInfoText || undefined}
        />
      )}
      {showPaymentModal && (
        <PaymentModal
          onClose={closePaymentModal}
          subscriptionType={subscriptionType}
          subscriptionEndDate={subscriptionEndDate}
          user_id={user_id}
        />
      )}
      <LeftSidebar
      />
      <div className="topics-main">
        <h1 className="topics-title">Выбери тему</h1>
        <h1 className="topics-subtitle">Здесь собраны все топики теории с задачами</h1>
        <div className="topics-scrollable">
          {topics.map((topic, index) => (
            <TopicCard
              key={index}
              title={topic.title_front}
              progress={topic.progress}
              g_status={topic.g_status}
              onClick={() => handleCardClick(topic.title, topic.course_name, topic.g_status, topic.order)}
            />
          ))}
        </div>
        <div className="total-t-progress-card">
          <TopicCard
            title="Общий прогресс"
            progress={totalProgress}
            onClick={() => alert("Total Progress Clicked!")}
          />
        </div>
      </div>
    </div>
  );
}

export default Topics;
